// src/services/feedbackService.ts
import { ref, push, get, set } from 'firebase/database';
import { db } from '../config/firebase';
import { Feedback } from '@/types/feedback';

const FEEDBACK_REF = 'feedbacks';

export const feedbackService = {
  async create(feedback: Omit<Feedback, 'id' | 'createdAt'>) {
    try {
      const newFeedback: Feedback = {
        ...feedback,
        id: '',
        createdAt: Date.now(),
        // userId: auth.currentUser?.uid || 'anonymous',
      };

      const newFeedbackRef = await push(ref(db, FEEDBACK_REF));
      const id = newFeedbackRef.key as string;

      await set(ref(db, `${FEEDBACK_REF}/${id}`), {
        ...newFeedback,
        id,
      });

      return {
        ...newFeedback,
        id,
      };
    } catch (error) {
      console.error('Error creating feedback:', error);
      throw new Error('Failed to submit feedback. Please try again.');
    }
  },

  async getAll(): Promise<Feedback[]> {
    try {
      const feedbacksRef = ref(db, FEEDBACK_REF);
      const snapshot = await get(feedbacksRef);

      if (!snapshot.exists()) {
        return [];
      }

      const feedbacks: Feedback[] = [];
      snapshot.forEach(childSnapshot => {
        const feedback = childSnapshot.val();
        feedbacks.push(feedback);
      });

      // Sort by createdAt in descending order (newest first)
      return feedbacks.sort((a, b) => b.createdAt - a.createdAt);
    } catch (error) {
      console.error('Error fetching feedbacks:', error);
      throw error;
    }
  },
};
